import {
  addBlock,
  blockHasValue,
  changeBlock,
  getBlocksFieldname,
  getBlocksLayoutFieldname,
  insertBlock,
} from '@plone/volto/helpers/Blocks/Blocks';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import ReactDOM from 'react-dom';

export function createImageBlock(imageData, index, props, intl) {
  const { properties, onChangeField, onSelectBlock } = props;

  const url = flattenToAppURL(imageData['@id']);
  const { alt = '', image_caption = '' } = imageData;

  const blocksFieldname = getBlocksFieldname(properties);
  const blocksLayoutFieldname = getBlocksLayoutFieldname(properties);

  const currBlockId = properties.blocks_layout.items[index];
  const currBlockHasValue = blockHasValue(properties.blocks[currBlockId]);
  let id, newFormData;

  const imageBlockData = {
    '@type': 'image',
    url,
    alt,
    caption: image_caption,
  };

  if (currBlockHasValue) {
    [id, newFormData] = addBlock(properties, 'image', index + 1, null, intl);
    newFormData = changeBlock(newFormData, id, imageBlockData);
  } else {
    [id, newFormData] = insertBlock(properties, currBlockId, imageBlockData);
  }

  ReactDOM.unstable_batchedUpdates(() => {
    onChangeField(blocksFieldname, newFormData[blocksFieldname]);
    onChangeField(blocksLayoutFieldname, newFormData[blocksLayoutFieldname]);
    onSelectBlock(id);
  });
}
